// Feature-toggle spec names used across the widget.
// Petri spec: petri-specs/specs.vod.OoiEditorFlow.json
//
// OFF (control group) → pre-existing classic behavior (reload on id change, Wix.resizeComponent,
// Wix.Data id migration). ON → OOI reactive flow (in-place reinit, no page reload).
export const OOI_EDITOR_FLOW_SPEC = 'specs.vod.OoiEditorFlow';
